import type { AccessContact } from '@assessments/shared'
import { PageLayout } from '@/components/common/PageLayout'
import { LockIcon } from '@/components/ui/icons'
import { StatusCard } from './StatusCard.js'

interface Props {
  contact: AccessContact | null
}

export function NoAccessPage({ contact }: Props) {
  const organization = contact?.organizationName
  const owner = contact?.ownerName
  // "Lorem Industries, Inc." already ends the sentence; do not add a second period.
  const orgClause = organization
    ? ` for ${organization}${organization.endsWith('.') ? '' : '.'}`
    : '.'
  return (
    <PageLayout title="Manage Assessments">
      <StatusCard icon={LockIcon} title="You don’t have access to your organization’s assessments">
        <p className="copy mx-auto max-w-2xl text-subtle">
          Your account isn’t listed as a collaborator on any assessment
          {orgClause} Contact your assessment owner
          {owner ? (
            <>
              , <strong className="text-body">{owner}</strong>,
            </>
          ) : (
            ''
          )}{' '}
          to request access and collaborate on the assessment.
        </p>
      </StatusCard>
    </PageLayout>
  )
}
